import React from "react";
import DropMenu from "../../reusable/DropMenu/DropMenu";
import IconTextButton from "../../reusable/Button/IconTextButton";
import RightAlign from "../../../assets/rightAlign.svg";
import LeftAlign from "../../../assets/leftAlign.svg";
import CenterAlign from "../../../assets/centerAlign.svg";

export default function AlignmentMenu({ setAlignment, onClose }) {
	return (
		<DropMenu position="bottom" onClose={onClose}>
			<IconTextButton
				text="Center"
				icon={CenterAlign}
				action={() => setAlignment("center")}
			/>
			<IconTextButton
				text="Left"
				icon={LeftAlign}
				action={() => setAlignment("left")}
			/>
			<IconTextButton
				text="Right"
				icon={RightAlign}
				action={() => setAlignment("right")}
			/>
		</DropMenu>
	);
}
